import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/modal.css';
import './assets/css/login.css';
import Router from './router/Router'; 

ReactDOM.render(<Router />, document.getElementById('root'));

